import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { NgClass } from "@angular/common";

@Component({
  selector: "app-icon",
  standalone: true,
  imports: [NgClass],
  templateUrl: "./icon.component.html",
  styleUrl: "./icon.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  @Input()
  public name!: string;

  @Input()
  public isPhosphor = false;

  @Input()
  public size: "xsmall" | "small" | "medium" | "large" = "small";
}
